import AnimatedLine, { AnimatedLineConfig } from "./AnimatedLine";

const config: AnimatedLineConfig = {
    viewBox: "0 0 532 255",
    path: "M0.375 254.268C84.9206 158.67 386.598 228.513 531.375 0.267578",
    dots: [
        { cx: 133.375, cy: 198.655, r: 8, delay: 0.6 },
        { cx: 245.375, cy: 176.547, r: 8, delay: 1.2 },
    ],
    gradient: { x: 265.875, y1: 0.267578, y2: 254.268 },
};

const Line4 = ({ className }: { className?: string }) => (
    <AnimatedLine {...config} className={className} />
);

export default Line4;
